import {
  createContext,
  type Dispatch,
  type ReactNode,
  useReducer,
} from "react";
import ScheduleValidationSnackbar from "@/pages/human-resources/time-management/components/schedule-validation/ScheduleValidationSnackbar.tsx";
import { noop } from "@/shared/utils/Events.ts";

interface Properties {
  children: ReactNode;
}

interface ScheduleValidationSnackBarState {
  open: boolean;
  validatedCount: number;
}

const ScheduleValidationSnackBarStateContext =
  createContext<ScheduleValidationSnackBarState>({
    open: false,
    validatedCount: 0,
  });

// eslint-disable-next-line react-refresh/only-export-components
export const ScheduleValidationSnackBarStateDispatchContext =
  createContext<Dispatch<ScheduleValidationSuccessAction>>(noop);

type ScheduleValidationSuccessAction =
  | { type: "open"; validatedCount: number }
  | { type: "close" };

function reducer(
  _: ScheduleValidationSnackBarState,
  action: ScheduleValidationSuccessAction,
): ScheduleValidationSnackBarState {
  switch (action.type) {
    case "open":
      return { open: true, validatedCount: action.validatedCount };
    case "close":
      return { open: false, validatedCount: 0 };
  }
}

export default function ScheduleValidationSnackbarProvider(
  props: Properties,
): ReactNode {
  const [snackState, dispatch] = useReducer(reducer, {
    open: false,
    validatedCount: 0,
  });

  return (
    <ScheduleValidationSnackBarStateContext.Provider value={snackState}>
      <ScheduleValidationSnackBarStateDispatchContext.Provider value={dispatch}>
        {props.children}
        <ScheduleValidationSnackbar
          open={snackState.open}
          onClose={() => {
            dispatch({ type: "close" });
          }}
          validatedCount={snackState.validatedCount}
        />
      </ScheduleValidationSnackBarStateDispatchContext.Provider>
    </ScheduleValidationSnackBarStateContext.Provider>
  );
}
